import styled, { css } from 'styled-components';

const ColumnBlockWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: ${({ theme }) => theme.grid.columnGap} 0;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-gap: ${({ theme }) => theme.grid.columnGap};
  }

  ${({ $columnWidth }) => $columnWidth < 6 && css`
    && {
      grid-gap: ${({ theme }) => theme.grid.columnGap} 0;
    }
  `};

`;

export default ColumnBlockWrapper;
